module.exports = __webpack_public_path__ + "img/png12(1).a89f9caa.png";